"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var WhatIsCoveredWidget = /** @class */ (function (_super) {
    __extends(WhatIsCoveredWidget, _super);
    function WhatIsCoveredWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhatIsCoveredWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18" }, "Whats's covered"),
            React.createElement("ul", { className: "list-unstyled font-family-base bullet-points ml-3" },
                React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-green-tick-2.svg", alt: "tick icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Fire")),
                React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-green-tick-2.svg", alt: "tick icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Theft and vandalism")),
                React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-green-tick-2.svg", alt: "tick icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Flooding and burst pipes")),
                this.props.interaction.factors.accidentalDamageProtection && (React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-green-tick-2.svg", alt: "tick icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Accidental damage")))),
            React.createElement("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18 mt-3" }, "Whats's not covered"),
            React.createElement("ul", { className: "list-unstyled font-family-base bullet-points ml-3" },
                React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-red-cross.svg", alt: "cross icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Gradual wear and tear")),
                React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-red-cross.svg", alt: "cross icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Breakdown of household appliances and electricals")),
                !this.props.interaction.factors.accidentalDamageProtection && (React.createElement("li", { className: "media mb-2" },
                    React.createElement("img", { className: "mt-1 mr-3", src: "/img/Flow-red-cross.svg", alt: "cross icon" }),
                    React.createElement("div", { className: "font-weight-extra-light" }, "Accidental damage"))))));
    };
    return WhatIsCoveredWidget;
}(plugin_journey_1.WidgetBase));
exports.default = WhatIsCoveredWidget;
//# sourceMappingURL=WhatIsCoveredWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/subscription/renters/WhatIsCoveredWidget.js
// module id = 2569
// module chunks = 0